// @flow

import { isMaxLength, isMinLength } from "./String";
import { isNumber } from "./isNumber";

export const isGermanAccountNumber = [isNumber, isMinLength(1), isMaxLength(10)];
